export class PetProcsModel {
    tran_sequence: number
    sup_sequence: number
    link_no: number
    link_type: number
    item_type: string
    unit: string
    unit_cost: string
    status: string
    inv_date: string
    req_date: string
    appr_date: string
    done_date: string
    req_by: string
    req_employee_initial: string
    done_by: string
    done_employee_initial: string
    appr_by: string
    appr_employee_initial: string
    inv_by: string
    inv_employee_initial: string
    pstatus: string
    tax: string
    response1: string
    response2: string
    approval: string
    chk_cost: string
    cost: string
    sub_cost: string
    distr_method: string
    route: string
    start_time: string
    moved: string
    printed: string
    recall_date: string
    clinic_no: string
    optional: string
    rerequest: string
    location: string
    basechg: string
    code_no: number
    code_type: number
    code_name: string
    procedure_desc: string
    pet_no: number
    client_no: number
    link_name: string
    link_desc: string
    link_fix: string
    wtime: string
    supervisor: number
    attending: number
    visible: boolean
    dosage: number
    days: number           //Linkage (overriding) base charge.
    altdays: number
    frequency: string
    indicationID: number
    qty: number
    notes: string
    remain_times: number
    dosageunit: string
    children: PetProcsModel[]
    indications?: string
    reason?: string
    // Not part of the constructor (avoids touching every positional call site) - set
    // directly after construction. True only for rows TreatGen/TreatGenEst generated as
    // a recurring-treatment occurrence; Status "R" alone also covers ordinary requests.
    is_treatment?: boolean | string | number

    constructor(
        tran_sequence: number,
        sup_sequence: number,
        link_no: number,
        link_type: number,
        item_type: string,
        unit: string,
        unit_cost: string,
        status: string,
        inv_date: string,
        req_date: string,
        appr_date: string,
        done_date: string,
        req_by: string,
        req_employee_initial: string,
        done_by: string,
        done_employee_initial: string,
        appr_by: string,
        appr_employee_initial: string,
        inv_by: string,
        inv_employee_initial: string,
        pstatus: string,
        tax: string,
        response1: string,
        response2: string,
        approval: string,
        chk_cost: string,
        cost: string,
        sub_cost: string,
        distr_method: string,
        route: string,
        start_time: string,
        moved: string,
        printed: string,
        recall_date: string,
        clinic_no: string,
        optional: string,
        rerequest: string,
        location: string,
        basechg: string,
        code_no: number,
        code_type: number,
        code_name: string,
        procedure_desc: string,
        pet_no: number,
        client_no: number,
        link_name: string,
        link_desc: string,
        link_fix: string,
        wtime: string,
        supervisor: number,
        attending: number,
        visible: boolean,
        dosage: number,
        days: number ,  
        altdays: number,
        frequency: string,
        indicationID: number,      //Linkage (overriding) base charge.
        qty: number,
        notes: string,
        remain_times: number,
        dosageunit: string,
        children: PetProcsModel[],
        indications?: string,
        reason?: string
    ) {
        this.tran_sequence = tran_sequence
        this.sup_sequence = sup_sequence
        this.link_no = link_no
        this.link_type = link_type
        this.item_type = item_type
        this.unit = unit
        this.unit_cost = unit_cost
        this.status = status
        this.inv_date = inv_date
        this.req_date = req_date
        this.appr_date = appr_date
        this.done_date = done_date
        this.req_by = req_by
        this.req_employee_initial = req_employee_initial
        this.done_by = done_by
        this.done_employee_initial = done_employee_initial
        this.appr_by = appr_by
        this.appr_employee_initial = appr_employee_initial
        this.inv_by = inv_by
        this.inv_employee_initial = inv_employee_initial
        this.pstatus = pstatus
        this.tax = tax
        this.response1 = response1
        this.response2 = response2
        this.approval = approval
        this.chk_cost = chk_cost
        this.cost = cost
        this.sub_cost = sub_cost
        this.distr_method = distr_method
        this.route = route
        this.start_time = start_time
        this.moved = moved
        this.printed = printed
        this.recall_date = recall_date
        this.clinic_no = clinic_no
        this.optional = optional
        this.rerequest = rerequest
        this.location = location
        this.basechg = basechg
        this.code_no = code_no
        this.code_type = code_type
        this.code_name = code_name
        this.procedure_desc = procedure_desc
        this.pet_no = pet_no
        this.client_no = client_no
        this.link_name = link_name
        this.link_desc = link_desc
        this.link_fix = link_fix
        this.wtime = wtime
        this.supervisor = supervisor
        this.attending = attending
        this.dosage = dosage
        this.days = days        //Linkage (overriding) base charge.
        this.altdays = altdays
        this.frequency = frequency
        this.indicationID = indicationID
        this.qty = qty
        this.notes = notes
        this.visible = visible
        this.dosageunit = dosageunit
        this.remain_times = remain_times
        this.children = children
        this.indications = indications
        this.reason = reason
    }
}